export default __webpack_public_path__ + "static/media/zoner9.2b094491.png";